import React from 'react';
import { ACLAuthorizationRequest } from '@/api/bol';
import { LogisticsObjectFormDialog } from '@/components/common/LogisticsObjectFormDialog';
import { defaultInvoicingDocumentTemplate } from '@/utils/invoicingDocumentDefaultTemplate';

export interface InvoicingDocumentFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { memberIdentifier: string; invoicingDocumentJson: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => Promise<void>;
}

export const InvoicingDocumentFormDialog: React.FC<InvoicingDocumentFormDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const handleSubmit = async (data: { memberIdentifier: string; jsonData: string; invoicingDocumentJson?: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => {
    const transformedData = {
      memberIdentifier: data.memberIdentifier,
      invoicingDocumentJson: data.invoicingDocumentJson || data.jsonData,
      aclAuthorizations: data.aclAuthorizations,
    };

    await onSubmit(transformedData);
  };

  return (
    <LogisticsObjectFormDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Create New InvoicingDocument"
      jsonFieldName="invoicingDocumentJson"
      defaultJsonTemplate={defaultInvoicingDocumentTemplate()}
      jsonLabel="Enter a valid InvoicingDocument JSON according to the SDL schema:"
      jsonHelperText="The JSON must conform to the InvoicingDocument schema defined in the BOL API"
      submitButtonText="Create"
    />
  );
};
